module.exports = __webpack_public_path__ + "bd02b9bbd21c0136ed33dca8b6cf2019.png";